export default __webpack_public_path__ + "static/media/logo.8935b623.png";